import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { AiProviderError, AiProviderService, AiSettingsGet } from '@app/services/ai-provider.service';

@Component({
    selector: 'tt-ai-settings',
    templateUrl: './ai-settings.component.html',
    styleUrls: ['./ai-settings.component.css'],
    standalone: false,
})
export class AiSettingsComponent implements OnInit, OnDestroy {
    public page?: AiSettingsGet;

    public loading = false;

    public hasProviders = false;

    public openedTabs = new Set<string>();

    public errorMessage = '';

    public translateErrorMessage = false;

    constructor(
        private readonly aiProvider: AiProviderService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    private async init(): Promise<void> {
        if (this.loading) return;

        this.loading = true;
        this.errorMessage = '';

        try {
            this.page = await this.aiProvider.getAiSettings();
            this.hasProviders = Number(this.page.ai_provider_keyno) > 0;
            if (!this.hasProviders) this.page.main_tab = 'SETUP';
            this.onTabChanged();
        } catch (error: unknown) {
            this.translateErrorMessage = error instanceof AiProviderError || !(error instanceof Error);
            this.errorMessage = error instanceof AiProviderError ? error.translationId : error instanceof Error ? error.message : 'ai_settings_provider_error';
        } finally {
            this.loading = false;
        }
    }

    public onTabChanged(): void {
        if (this.page) this.openedTabs.add(this.page.main_tab);
    }

    public async ngOnInit(): Promise<void> {
        this.navigator?.setHeading?.('p2_m_aisettings', true);
        this.navigator?.setSize?.({ width: '98vw', height: '95vh' });
        await this.init();
    }

    public ngOnDestroy(): void {
        if (this.page) this.page.api_key = '';
    }
}
